import SearchTerms from "./search-terms";

export default SearchTerms;